import React from 'react'

/**
 * TasksSection — session-scoped task list.
 *
 * The TaskList component requires reportId/managerId/currentUserId for its
 * data-fetching path. These are derived from the session + me props.
 *
 * For now we render a placeholder notice; the full TaskList wiring is a
 * follow-up once the TaskList API surface is confirmed against the canvas
 * context (pairId resolution from session object).
 *
 * Props:
 *   session       object — session object
 *   me            object — current user
 *   disabled      boolean
 */
export function TasksSection({ session, me, disabled }) {
  // TODO(follow-up): wire TaskList with reportId/managerId derived from session
  // once the canvas data context is confirmed.

  return (
    <div className="tasks-section" data-testid="tasks-section">
      <p className="viewing-notice">
        Tasks — wiring in progress.
      </p>
    </div>
  )
}
